import { useEffect, useState } from "react";
import { ip } from "../api/api";
import { Spinner } from "../atoms/spinner";
import defaultLogo from "../assets/expligo_icon.png";

export function LoadingScreen({ brandingLogo, fadeOut = false }) {
    const [logo, setLogo] = useState(defaultLogo);
    const [animationClass, setAnimationClass] = useState("scale-up");
    const [showBrandingLogo, setShowBrandingLogo] = useState(false);
    const [fadeClass, setFadeClass] = useState("");
    const [finalAnimationClass, setFinalAnimationClass] = useState("");
    const [animationKey, setAnimationKey] = useState(0);

    useEffect(() => {
        setAnimationClass("scale-up");
    }, []);
    function handleAnimationEnd() {
        if (!showBrandingLogo && brandingLogo && brandingLogo.length > 0) {
            setAnimationClass("");
            setFadeClass("scale-down");

            setTimeout(() => {
                setLogo(`${ip}/api/media/${brandingLogo}`);
                setShowBrandingLogo(true);
                setFadeClass("scale-up");
                setAnimationKey(prev => prev + 1); 
            }, 600);
        } else if (fadeClass === "scale-up") {
            setFadeClass("");
            setFinalAnimationClass("scale-down");
        }
    }
  return (
    <div className={`loading-screen ${fadeOut ? "fade-out" : ""}`}>
      <img key={animationKey} src={logo} alt="Logo"className={`loading-logo ${animationClass} ${fadeClass} ${finalAnimationClass}`} onAnimationEnd={handleAnimationEnd} />
      <Spinner size="3.75rem" color="primary-600" thickness="0.3125rem" />
    </div>
  );
}